import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Container, Typography, Grid, Tooltip, useMediaQuery, Button, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/Footer";
import role from "../../redux/actions/role";
import SimpleSnackbar from "../../components/controls/ToastMessage";
import { codingLanguageDisplay } from "../../services/globalService";
import QuizSection from "./quizsections";
import BlockIcon from "@mui/icons-material/Block";
import TreemapChart from "../../components/chart/TreemapChart";
import ExperienceCards from "../CandidateProfile/ExperienceCards";
import EducationCards from "../CandidateProfile/EducationCards";
import ViewIcon from "../../assets/svg/viewicon.svg";
import { ImagebaseUrl } from "../../services/globalService";
import ExplainationModal from "../../components/ExplainationModal";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DownloadIcon from "@mui/icons-material/Download";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

// styles for this component
const useStyles = makeStyles({
  container: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingBottom: "3rem",
  },
  roletype: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletypeSwitch: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  grid_root: {
    marginTop: "0px !important",
    marginLeft: "0px !important",
  },

  link: {
    fontFamily: "Roboto",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0em",
    textalign: "left",
    textDecoration: "none !important",
    color: "#1789FC!important",
    "& .css-1ps4owl-MuiTypography-root-MuiLink-root": {
      textDecoration: "none !important",
      color: "#1789FC !important",
    },
  },

  leftSideContaint: {
    color: "#2F2F2F !important",
    fontStyle: "normal !important",
    fontWeight: "500  !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
  },
  leftSideContaint1: {
    color: "#2F2F2F !important",
    fontStyle: "normal !important",
    fontWeight: "500  !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
  },
  roletype2: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },

  hintIconCls: {
    marginLeft: "5px",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

export default function CandidateJobSpecificProfile() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { candidateId, roleId, profileToken } = useParams();
  const dispatch = useDispatch();
  const roleState = useSelector((state) => state.role);
  const isRoleLoading = useSelector((state) => state.role.isroleLoading);
  const isAuthLoading = useSelector((state) => state.auth.isauthLoading);
  const isInvitePageLoading = useSelector((state) => state.role.isCandidateRoleLoading);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [snacktext, setsnacktext] = useState("");
  const [open, setOpen] = useState(false);
  const [categoryToDisplay, setCategoryToDisplay] = useState([]);
  const [showExplanationModal, setShowExplanationModal] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [releventSkillFilter, setReleventSkillFilter] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [updatEdeducationReportData, setUpdatedEducationReportData] = useState(null);
  const [mappedSkills, setMappedSkills] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [secondaryLogo, setSecondaryLogo] = useState(null);

  const matches = useMediaQuery("(min-width:900px)");

  // Download Report
  const onDownloadReport = () => {
    let payload = {
      chartData: { data: [chartData?.plotlyData], layout: chartData?.layout },
      orgLogo: mainData?.orgLogo || "",
      topEducation: updatEdeducationReportData || "",
      reportUrl: window.location.href || "",
      candidate: {
        photoURL: mainData?.candidate?.photoURL || "",
        candidateId: mainData?.candidate?.candidateId || "",
        firstName: mainData?.candidate?.firstName || "",
        lastName: mainData?.candidate?.lastName || "",
        degree: mainData?.candidate?.degree || "",
        email: mainData?.candidate?.email || "",
        location: mainData?.candidate?.location || "",
        yoe: mainData?.candidate?.yoe || 0,
        workExperiences: mainData?.candidate?.weDetails?.length || 0,
        weSummary: mainData?.overallSummary,
      },
      skillMatch: mappedSkills || [],
      profileMatch: mainData?.profileMatch,
      jobRole: {
        jobRoleName: mainData?.jobRole?.name || "",
        jobDegree: mainData?.jobRole?.degree || "",
        jobYoe: mainData?.jobRole?.yoe || "",
        jobRoleType: mainData?.jobRole?.type || "",
        roleId: mainData?.jobRole?.roleId || "",
      },
    };
    if (mainData?.candidate?.candidateId) {
      dispatch(role.profileMatchReport(payload));
    }
  };

  // full name mapping for pdf report
  useEffect(() => {
    if (mainData?.skillMatch && mainData?.skillsMaster) {
      let updatedSkills = [];
      mainData?.skillMatch?.forEach((skill) => {
        let fullName = mainData?.skillsMaster[skill.skill].fullName;

        let mappedSkill = {
          skill: skill.skill,
          fullName: fullName,
          dots: skill.dots,
          points: skill.points,
        };

        updatedSkills.push(mappedSkill);
      });
      setMappedSkills(updatedSkills);
    }
  }, [mainData?.skillMatch, mainData?.skillsMaster]);

  // Download Report Success and Open in New Tab
  useEffect(() => {
    if (roleState.profileMatchReportSuccess) {
      window.open(roleState.profileMatchReportSuccess, "_self");
    }
  }, [roleState.profileMatchReportSuccess]);

  // get Tree Chart Data from child component
  const handleTreeChartData = (value) => {
    setChartData((prev) => (JSON.stringify(prev) !== JSON.stringify(value) ? value : prev));
  };

  // Handle Education Report Data
  const handleEducationReportData = (data) => {
    setUpdatedEducationReportData(data);
  };

  // Get Candidate Job Specific Profile
  useEffect(() => {
    let payload = {
      candidateId,
      roleId,
      profileToken,
    };
    dispatch(role.CandidateJobSpecificProfile(payload));
  }, []);

  // Set Main Data
  useEffect(() => {
    if (roleState?.CandidateJobSpecificProfileSuccess) {
      setMainData(roleState?.CandidateJobSpecificProfileSuccess?.data);
      setSkeletonLoading(false);
    }
  }, [roleState?.CandidateJobSpecificProfileSuccess]);

  // Set Logo URL
  useEffect(() => {
    if (mainData && mainData?.orgLogo == "") {
      setLogoUrl(`${process.env.REACT_APP_ASSETS_URL}techscore.svg`);
      setSecondaryLogo(null);
    } else {
      setSecondaryLogo(`${process.env.REACT_APP_ASSETS_URL}powered.svg`);
      setLogoUrl(`${process.env.REACT_APP_ASSETS_URL}${mainData?.orgLogo}`);
    }
  }, [mainData?.orgLogo]);

  // Set Snack Bar
  useEffect(() => {
    if (roleState?.CandidateJobSpecificProfileFailure) {
      // console.log("*************");
      navigate("/inValidAccess");
    }
    // eslint-disable-next-line
  }, [roleState?.CandidateJobSpecificProfileFailure]);

  useEffect(() => {
    if (roleState?.roleCategories && mainData?.jobRole?.category) {
      const categoryMapping = roleState?.roleCategories;
      if (categoryMapping && Array.isArray(mainData?.jobRole?.category)) {
        const categoryDisplayValue = mainData?.jobRole?.category?.map((category) => categoryMapping[category]);
        setCategoryToDisplay(categoryDisplayValue);
      }
    }
  }, [roleState?.roleCategories, mainData?.jobRole?.category]);

  //extract username from linkedin
  const extractUsernameFromLink = (link) => {
    if (!link?.includes("https://")) {
      link = `https://${link}`;
    }
    const url = new URL(link);
    const pathParts = url.pathname.split("/").filter((part) => part !== ""); // Filter out empty parts
    return pathParts[pathParts.length - 1];
  };

  //handle hint click
  const handlehintClick = () => {
    setShowExplanationModal(true);
    setOpenPopup(true);
  };

  // hadle switch change
  const handleSwitchChange = (event) => {
    if (event.target.checked) {
      console.log("Switch toggled on");
      setReleventSkillFilter(true);
    } else {
      console.log("Switch toggled off");
      setReleventSkillFilter(false);
    }
  };

  return (
    <Grid>
      {/* desktop view */}
      {matches ? (
        <div>
          <Grid
            style={{
              position: "fixed",
              top: "0",
              zIndex: "2",
              width: "100%",
              backgroundColor: "#FFFBF6",
              height: "100px",
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              alignItems: "center",
            }}
          >
            {/* {mainData?.candidate?.candidateId && ( */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "start", paddingLeft: "20px" }}>
              {mainData && logoUrl && secondaryLogo ? (
                <>
                  {" "}
                  <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                    <img src={logoUrl} alt="LOGO" style={{ height: "42px", width: "170px" }} />
                  </a>
                  <img src={secondaryLogo} alt="LOGO" style={{ width: "170px" }} />
                </>
              ) : mainData && logoUrl ? (
                <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                  <img src={logoUrl} alt="LOGO" style={{ height: "42px" }} />
                </a>
              ) : null}
            </div>
            {/* )} */}
            <div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "20px" }}>
                <Typography variant="h5" style={{ fontWeight: "600" }}>
                  Profile Match
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "20px" }}>
                <Typography style={{ fontWeight: "600", fontSize: "15px" }}>
                  Candidate ID {mainData?.candidate?.candidateId} {"|"} Role ID {mainData?.jobRole?.roleId}
                </Typography>
              </div>
            </div>
          </Grid>
          {!skeletonLoading ? (
            <>
              <Container maxWidth="xl" className={classes.container}>
                <Grid style={{ marginTop: "100px" }}>
                  {!isAuthLoading && !isInvitePageLoading ? (
                    <Grid>
                      <Grid container spacing={2}>
                        {/* Left Side */}
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2} xl={2} lg={2}>
                          <Grid container>
                            <Grid item xs={12} style={{ marginTop: "25px" }}>
                              <Typography variant="h6">
                                {mainData?.candidate?.firstName} {mainData?.candidate?.lastName}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "35px" }}>
                              <img src={mainData?.candidate?.photoURL} alt="photoURL" style={{ width: "81%" }} />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                                Candidate Details
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography className={classes.roletype}>Candidate ID</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {mainData?.candidate?.candidateId}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                              <Typography className={classes.roletype}>Degree</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {mainData?.candidate?.degree}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                              <Typography className={classes.roletype}>Experience</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {mainData?.candidate?.yoe} Years
                              </Typography>
                            </Grid>
                            {mainData?.candidate?.location && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Location</Typography>
                                <Typography className={classes.leftSideContaint}>
                                  {mainData?.candidate?.location}
                                </Typography>
                              </Grid>
                            )}
                            {mainData?.candidate?.email && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Email</Typography>
                                <Typography
                                  style={{
                                    color: "#2F2F2F",
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    marginTop: "8px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {mainData?.candidate?.email}
                                </Typography>
                              </Grid>
                            )}
                            {mainData?.candidate?.linkedInProfile && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>LinkedIn</Typography>
                                <Typography className={classes.leftSideContaint}>
                                  {/* {mainData?.candidate?.linkedInProfile?.match(/\/in\/([^\/]+)/)[1]}{" "} */}
                                  {extractUsernameFromLink(mainData?.candidate?.linkedInProfile)}{" "}
                                  <span>
                                    <img
                                      src={ViewIcon}
                                      alt="ViewIcon"
                                      onClick={() => window.open(mainData?.candidate?.linkedInProfile, "_blank")}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </span>
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>

                        <Grid item xs={8} xl={8} lg={8}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              style={{
                                marginTop: "25px",
                                display: "flex",
                                justifyContent: "space-between",
                                marginRight: "16px",
                              }}
                            >
                              <Typography variant="h6">Role Details</Typography>
                              {mainData?.candidate && (
                                <Button
                                  onClick={onDownloadReport}
                                  variant="outlined"
                                  endIcon={<DownloadIcon />}
                                  sx={{ textTransform: "none" }}
                                  disabled={isRoleLoading}
                                >
                                  Download PDF
                                </Button>
                              )}
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Role ID</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {mainData?.jobRole?.roleId}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Role Category</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {categoryToDisplay.length > 0 ? categoryToDisplay : []}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Role Name</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {mainData?.jobRole?.name}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Required Degree</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {mainData?.jobRole?.degree}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Required Experience</Typography>
                                <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                  {mainData?.jobRole?.yoe} Years
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid container direction="column">
                                <Typography className={classes.roletype}>Coding Language</Typography>
                                <Tooltip
                                  title={
                                    mainData?.jobRole?.codingLang ? mainData?.jobRole?.codingLang.join(" / ") : "--"
                                  }
                                  placement="bottom-start"
                                >
                                  <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                    {codingLanguageDisplay(
                                      mainData?.jobRole?.codingLang ? mainData?.jobRole?.codingLang : ["--"]
                                    )}
                                  </Typography>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              style={{ marginTop: "25px", display: "flex", justifyContent: "space-between" }}
                            >
                              <Typography variant="h6"></Typography>
                            </Grid>
                            {mainData?.overallSummary !== "NA" && mainData?.overallSummary !== "" ? (
                              <Grid
                                className={classes.roletype}
                                sx={{
                                  padding: "24px",
                                  textAlign: "justify",
                                  lineHeight: "1.92 !important",
                                  // marginTop: "40px",
                                  color: "#000000 !important",
                                  minHeight: "202px",
                                }}
                              >
                                {mainData?.overallSummary}
                              </Grid>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  minHeight: "135px",
                                  width: "100%",
                                  marginTop: "56px",
                                }}
                                className={classes.roletype}
                              >
                                <span>
                                  <BlockIcon />
                                </span>{" "}
                                <Typography
                                  sx={{ marginLeft: "5px", marginBottom: "13px" }}
                                  className={classes.roletype}
                                >
                                  Relevant Summary Not Available.
                                </Typography>
                              </div>
                            )}
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container className={classes.grid_root}>
                              <Grid item xs={11.8}>
                                <QuizSection data={mainData ? mainData : []} />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} lg={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={9.9}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    marginTop: "25px",
                                    marginBottom: "25px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Grid item xs={6}>
                                    <Typography variant="h6">
                                      {releventSkillFilter ? "Relevant Technical Skills" : "All Technical Skills"}
                                      {mainData?.candidate?.skills?.length ? (
                                        <span>
                                          <img
                                            alt="hintImg"
                                            src={`${ImagebaseUrl}assets/questionsInformationIcon.svg`}
                                            className={classes.hintIconCls}
                                            onClick={handlehintClick}
                                          />
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </Typography>{" "}
                                  </Grid>
                                  <Grid item xs={6} container justifyContent="flex-end">
                                    {mainData?.jobRole?.relevantSkillsByJD &&
                                      mainData?.jobRole?.relevantSkillsByJD?.length && (
                                        <FormControlLabel
                                          value="start"
                                          control={<Switch color="primary" onChange={handleSwitchChange} />}
                                          label={
                                            <span className={classes.roletypeSwitch}>Show only relevant skills</span>
                                          }
                                          labelPlacement="start"
                                        />
                                      )}
                                  </Grid>
                                </Grid>
                                {showExplanationModal && (
                                  <ExplainationModal
                                    openPopup={openPopup}
                                    setOpenPopup={setOpenPopup}
                                    treeMapData={mainData?.candidate?.skills}
                                    candidateDetails={mainData?.candidate}
                                    skillsMaster={mainData?.skillsMaster}
                                  />
                                )}

                                <Box
                                  style={{
                                    border: "solid 1px rgba(224, 224, 224, 1)",
                                    borderRadius: "8px",
                                    height: "515px",
                                    width: "96.5%",
                                    padding: "20px",
                                    margin: "20px",
                                    marginLeft: "0px",
                                  }}
                                >
                                  <TreemapChart
                                    flag={releventSkillFilter}
                                    releventSkills={
                                      mainData?.jobRole?.relevantSkillsByJD
                                        ? [...mainData?.jobRole?.relevantSkillsByJD]
                                        : []
                                    }
                                    setChartData={handleTreeChartData}
                                    treeMapData={mainData?.candidate?.skills ? [...mainData?.candidate?.skills] : []}
                                    skillsMaster={mainData?.skillsMaster}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={9.9}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <ExperienceCards
                                weDetails={mainData?.candidate?.weDetails}
                                skillsMaster={mainData?.skillsMaster}
                              />
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={9.9}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <EducationCards
                                education={mainData?.candidate?.education}
                                handleEducationReportData={handleEducationReportData}
                              />
                              <p
                                style={{
                                  borderBottom: "1px solid #C4C4C4",
                                  width: "100%",
                                  marginTop: "40px",
                                  // marginBottom: "0px",
                                }}
                              />
                              <Typography className={classes.roletype2}>
                                Beta Feature Disclaimer:
                                <span className={classes.leftSideContaint1}>
                                  {" "}
                                  This report is a feature in beta. Use the information displayed here with caution and
                                  cross verify it with the candidate resume. If you find any discrepancies you may
                                  report them to{" "}
                                  <a href="mailto:support@techscore.ai" style={{ color: "black" }}>
                                    support@techscore.ai
                                  </a>
                                </span>
                              </Typography>
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          {/* <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} /> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Container>
              {/* <Footer /> */}

              <SimpleSnackbar open={open} setOpen={setOpen} text={snacktext} />
            </>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={1} mt={"80px"} width={"80%"}>
                <Grid item xs={12} md={12}>
                  <Grid container item xs={12} md={12} columnSpacing={4} mt={4}>
                    <Grid container item xs={3} md={3} height={"700px"}>
                      <Grid item xs={12} md={12}>
                        <Box mb={2}>
                          <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} />
                        </Box>
                      </Grid>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="170px" height="180px" />
                      <Skeleton variant="text" sx={{ fontSize: "12px", width: "100%", marginBottom: "20px" }} />

                      {Array.from({ length: 4 }).map((_, index) => (
                        <Stack width={"100%"} height={"60px"} spacing={0.8}>
                          <Skeleton key={index} variant="text" sx={{ fontSize: "22px", width: "80%" }} />
                          <Skeleton key={index} variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        </Stack>
                      ))}
                    </Grid>

                    <Grid container item xs={9} md={9}>
                      <Grid item xs={12} md={12}>
                        <Box mb={2} sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />
                        </Box>
                      </Grid>

                      <Grid container item xs={12} md={12} spacing={2} mt={1.5}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} marginTop={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} md={12} spacing={2} mt={2}>
                        <Grid item xs={12} md={12} mt={1.5}>
                          <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "20px", width: "40%" }} />
                        </Grid>
                      </Grid>

                      <Grid container item xs={12} md={12} columnSpacing={4}>
                        <Grid container item xs={12} spacing={2} md={12} mt={1}>
                          <Grid item xs={6} md={6}>
                            <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={3} md={3}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "70%" }} />
                    </Grid>
                    <Grid item xs={3} md={3}>
                      {/* <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} /> */}
                    </Grid>
                    <Grid item xs={3} md={3}>
                      {/* <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} /> */}
                    </Grid>
                    <Grid item xs={3} md={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "50%" }} />
                    </Grid>
                    <Grid item xs={12} md={12} mt={6}>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="400px" />
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={12} md={12} mt={3}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "10%" }} />

                      <Stack spacing={2} mt={4}>
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                      </Stack>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                  <Grid container item xs={12} md={12}>
                    <Grid item xs={12} md={12} mt={1}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />

                      <Grid item xs={12} md={12} mt={2}>
                        {Array.from({ length: 3 }).map((_, index) => (
                          <Box sx={{ display: "flex", justifyContent: "flex-start", gap: "14px" }}>
                            <Skeleton variant="text" sx={{ fontSize: "25px", width: "10%" }} />
                            <Skeleton variant="text" sx={{ fontSize: "25px", width: "90%" }} />
                          </Box>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} rowSpacing={5} columnSpacing={4} mb={5}>
                    <Grid item xs={12} md={12}>
                      <Stack spacing={0.8}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "45%" }} />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
      ) : (
        <div>
          {/* mobile and tablet view */}
          <Grid
            style={{
              position: "fixed",
              top: "0",
              zIndex: "2",
              width: "100%",
              backgroundColor: "#FFFBF6",
              height: "100px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "2px" }}>
              {mainData && logoUrl && secondaryLogo ? (
                <>
                  {" "}
                  <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                    <img src={logoUrl} alt="LOGO" style={{ height: "42px", width: "170px" }} />
                  </a>
                  <img src={secondaryLogo} alt="LOGO" style={{ width: "170px" }} />
                </>
              ) : mainData && logoUrl ? (
                <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                  <img src={logoUrl} alt="LOGO" style={{ height: "42px" }} />
                </a>
              ) : null}
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Typography variant="h6" style={{ fontWeight: "600", padding: "1px" }}>
                Profile Match
              </Typography>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "0px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingLeft: "20px" }}>
                <Typography sx={{ fontWeight: "600", fontSize: "15px" }}>
                  Candidate ID {mainData?.candidate?.candidateId}
                </Typography>
              </div>

              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "20px" }}>
                <Typography style={{ fontWeight: "600", fontSize: "15px" }}>
                  Role ID {mainData?.jobRole?.roleId}
                </Typography>
              </div>
            </div>
          </Grid>
          {!skeletonLoading ? (
            <>
              <Container maxWidth="xl" className={classes.container}>
                <Grid style={{ marginTop: "100px" }}>
                  {!isAuthLoading && !isInvitePageLoading ? (
                    <Grid container spacing={2}>
                      {/* Left Side */}
                      <Grid item lg={4} md={12} sm={12} xs={12} spacing={2}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "40px",
                          }}
                        >
                          {mainData?.candidate && (
                            <Button
                              onClick={onDownloadReport}
                              variant="outlined"
                              endIcon={<DownloadIcon />}
                              sx={{ textTransform: "none" }}
                              disabled={isRoleLoading}
                            >
                              Download PDF
                            </Button>
                          )}
                          <Typography variant="h6" sx={{ textAlign: "center", marginTop: "7px" }}>
                            {mainData?.candidate?.firstName} {mainData?.candidate?.lastName}
                          </Typography>
                        </Box>

                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          style={{ marginTop: "35px", display: "flex", justifyContent: "center" }}
                        >
                          <img src={mainData?.candidate?.photoURL} alt="photoURL" style={{ width: "50%" }} />
                        </Grid>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12}>
                        <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                          Candidate Details
                        </Typography>
                      </Grid>
                      <Grid container lg={8} md={12} sm={12} xs={12} style={{ paddingLeft: "15px" }}>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Candidate ID</Typography>
                          <Typography className={classes.leftSideContaint}>
                            {mainData?.candidate?.candidateId}
                          </Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Degree</Typography>
                          <Typography className={classes.leftSideContaint}>{mainData?.candidate?.degree}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Experience</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Typography className={classes.leftSideContaint}>
                              {mainData?.candidate?.yoe} Years
                            </Typography>
                          </Typography>
                        </Grid>
                        {mainData?.candidate?.location && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Location</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {mainData?.candidate?.location}
                            </Typography>
                          </Grid>
                        )}
                        {mainData?.candidate?.email && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Email</Typography>
                            <Typography className={classes.leftSideContaint}>{mainData?.candidate?.email}</Typography>
                          </Grid>
                        )}
                        {/* {mainData?.candidate?.linkedInProfile && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>LinkedIn</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {extractUsernameFromLink(mainData?.candidate?.linkedInProfile)}

                              <span>
                                <img
                                  src={ViewIcon}
                                  alt="ViewIcon"
                                  onClick={() => window.open(mainData?.candidate?.linkedInProfile, "_blank")}
                                  style={{ cursor: "pointer" }}
                                />
                              </span>
                            </Typography>
                          </Grid>

                        )} */}

                        {mainData?.candidate?.linkedInProfile && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>LinkedIn</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {extractUsernameFromLink(mainData?.candidate?.linkedInProfile)}{" "}
                              <span>
                                <img
                                  src={ViewIcon}
                                  alt="ViewIcon"
                                  onClick={() => window.open(mainData?.candidate?.linkedInProfile, "_blank")}
                                  style={{ cursor: "pointer" }}
                                />
                              </span>
                            </Typography>
                          </Grid>
                        )}
                      </Grid>

                      <Grid item lg={12} md={12} sm={12}>
                        <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                          Role Details
                        </Typography>
                      </Grid>
                      <Grid container xs={12} sm={12} md={12} style={{ paddingLeft: "15px" }}>
                        <Grid item xs={4} sm={4} md={4}>
                          <Grid container direction="column">
                            <Typography className={classes.roletype}>Role ID</Typography>
                            <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                              {mainData?.jobRole?.roleId}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4}>
                          <Grid container direction="column">
                            <Typography className={classes.roletype}>Role Category</Typography>
                            <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                              {categoryToDisplay.length > 0 ? categoryToDisplay : []}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4}>
                          <Grid container direction="column">
                            <Typography className={classes.roletype}>Role Name</Typography>
                            <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                              {mainData?.jobRole?.name}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4}>
                          <Grid container direction="column">
                            <Typography className={classes.roletype}>Required Degree</Typography>
                            <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                              {mainData?.jobRole?.degree}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4}>
                          <Grid container direction="column">
                            <Typography className={classes.roletype}>Required Experience</Typography>
                            <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                              {mainData?.jobRole?.yoe} Years
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4}>
                          <Grid container direction="column">
                            <Typography className={classes.roletype}>Coding Language</Typography>
                            <Tooltip
                              title={mainData?.jobRole?.codingLang ? mainData?.jobRole?.codingLang.join(" / ") : "--"}
                              placement="bottom-start"
                            >
                              <Typography className={classes.roletype} style={{ color: "#2F2F2F" }}>
                                {codingLanguageDisplay(
                                  mainData?.jobRole?.codingLang ? mainData?.jobRole?.codingLang : ["--"]
                                )}
                              </Typography>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Grid>
                      {mainData?.overallSummary !== "NA" && mainData?.overallSummary !== "" ? (
                        <Grid
                          className={classes.roletype}
                          sx={{
                            padding: "16px",
                            paddingRight: "0px",
                            textAlign: "justify",
                            lineHeight: "1.5 !important",
                            color: "#000000 !important",
                            marginTop: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          {mainData?.overallSummary}
                        </Grid>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "135px",
                            width: "100%",
                            marginTop: "56px",
                          }}
                          className={classes.roletype}
                        >
                          <span>
                            <BlockIcon />
                          </span>{" "}
                          <Typography sx={{ marginLeft: "5px", marginBottom: "13px" }} className={classes.roletype}>
                            Relevant Summary Not Available.
                          </Typography>
                        </div>
                      )}

                      <Grid container className={classes.grid_root}>
                        <Grid item xs={12} sx={{ margin: "auto" }}>
                          <QuizSection data={mainData ? mainData : []} />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}
                      >
                        <Grid item xs={6}>
                          <Typography variant="h6">
                            {releventSkillFilter ? "Relevant Technical Skills" : "All Technical Skills"}

                            {mainData?.candidate?.skills?.length ? (
                              <span>
                                <img
                                  alt="hintImg"
                                  src={`${ImagebaseUrl}assets/questionsInformationIcon.svg`}
                                  className={classes.hintIconCls}
                                  onClick={handlehintClick}
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          {mainData?.jobRole?.relevantSkillsByJD && mainData?.jobRole?.relevantSkillsByJD?.length && (
                            <FormControlLabel
                              value="start"
                              control={<Switch color="primary" onChange={handleSwitchChange} />}
                              label={<span className={classes.roletypeSwitch}>Show only relevant skills</span>}
                              labelPlacement="start"
                            />
                          )}
                        </Grid>
                      </Grid>

                      {showExplanationModal && (
                        <ExplainationModal
                          openPopup={openPopup}
                          setOpenPopup={setOpenPopup}
                          treeMapData={mainData?.candidate?.skills}
                          candidateDetails={mainData?.candidate}
                          skillsMaster={mainData?.skillsMaster}
                        />
                      )}
                      <Box
                        style={{
                          border: "solid 1px rgba(224, 224, 224, 1)",
                          borderRadius: "8px",
                          height: "515px",
                          width: "100%",
                          padding: "10px",
                          // margin: "20px",
                          marginLeft: "15px",
                          // display: isGridVisible ? "none" : "block",
                        }}
                      >
                        <TreemapChart
                          flag={releventSkillFilter}
                          releventSkills={
                            mainData?.jobRole?.relevantSkillsByJD ? [...mainData?.jobRole?.relevantSkillsByJD] : []
                          }
                          setChartData={handleTreeChartData}
                          treeMapData={mainData?.candidate?.skills ? [...mainData?.candidate?.skills] : []}
                          skillsMaster={mainData?.skillsMaster}
                        />{" "}
                      </Box>

                      <Grid item xs={12} xl={8} lg={8}>
                        <Grid item xs={12} xl={12} lg={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <ExperienceCards
                                weDetails={mainData?.candidate?.weDetails}
                                skillsMaster={mainData?.skillsMaster}
                              />
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <EducationCards
                                education={mainData?.candidate?.education}
                                handleEducationReportData={handleEducationReportData}
                              />
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                          <Typography className={classes.roletype2}>
                            Beta Feature Disclaimer:
                            <span className={classes.leftSideContaint1}>
                              {" "}
                              This report is a feature in beta. Use the information displayed here with caution and
                              cross verify it with the candidate resume. If you find any discrepancies you may report
                              them to{" "}
                              <a href="mailto:support@techscore.ai" style={{ color: "black" }}>
                                support@techscore.ai
                              </a>
                            </span>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Container>
            </>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={1} mt={"80px"} width={"80%"}>
                <Grid item xs={12} md={12}>
                  <Grid item xs={12} md={12} mt={5}>
                    <Box
                      sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                    >
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                    </Box>
                  </Grid>
                  {/* <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                  <Grid container item xs={12} md={12} columnSpacing={4} mt={4}>
                    <Grid container item xs={12} md={12} justifyContent="center">
                      <stack>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="170px" height="180px" />
                      </stack>

                      <Grid container item xs={12} md={12} spacing={2} mt={2}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "25px", width: "70%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(2)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} md={12} spacing={2} mt={2}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "25px", width: "70%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container item xs={12} md={12} spacing={2} mt={2}>
                      <Grid item xs={12} md={12} mt={1.5}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "40%" }} />
                      </Grid>
                    </Grid>

                    <Grid container item xs={12} md={12} columnSpacing={4}>
                      <Grid container item xs={12} spacing={2} md={12} mt={1}>
                        <Grid item xs={6} md={6}>
                          <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                        </Grid>
                        <Grid item xs={6} md={6}>
                          <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="300px" />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                <Grid container item xs={12} md={12} columnSpacing={4} mt={2}>
                  <Grid item xs={3} md={3}>
                    <Skeleton variant="text" sx={{ fontSize: "40px", width: "70%" }} />
                  </Grid>
                  <Grid item xs={3} md={3}>
                    {/* <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} /> */}
                  </Grid>
                  <Grid item xs={3} md={3}>
                    {/* <Skeleton variant="text" sx={{ fontSize: "40px", width: "100%" }} /> */}
                  </Grid>
                  <Grid item xs={3} md={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Skeleton variant="text" sx={{ fontSize: "40px", width: "50%" }} />
                  </Grid>
                  <Grid item xs={12} md={12} mt={6}>
                    <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="400px" />
                  </Grid>
                </Grid>
                {/* <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                <Grid container item xs={12} md={12} columnSpacing={4}>
                  <Grid item xs={12} md={12} mt={3}>
                    <Skeleton variant="text" sx={{ fontSize: "40px", width: "10%" }} />

                    <Stack spacing={2} mt={4}>
                      <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                      <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                      <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                    </Stack>
                  </Grid>
                </Grid>
                <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                <Grid container item xs={12} md={12}>
                  <Grid item xs={12} md={12} mt={1}>
                    <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />

                    <Grid item xs={12} md={12} mt={2}>
                      {Array.from({ length: 3 }).map((_, index) => (
                        <Box sx={{ display: "flex", justifyContent: "flex-start", gap: "14px" }}>
                          <Skeleton variant="text" sx={{ fontSize: "25px", width: "10%" }} />
                          <Skeleton variant="text" sx={{ fontSize: "25px", width: "90%" }} />
                        </Box>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
                {/* <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                <Grid container item xs={12} md={12} rowSpacing={5} columnSpacing={4} mb={5} mt={1}>
                  <Grid item xs={12} md={12}>
                    <Stack spacing={0.8}>
                      <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                      <Skeleton variant="text" sx={{ fontSize: "20px", width: "45%" }} />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
      )}

      <Footer />
    </Grid>
  );
}
